import { render, staticRenderFns } from "./MatchEvent.vue?vue&type=template&id=56007289&"
import script from "./MatchEvent.vue?vue&type=script&lang=js&"
export * from "./MatchEvent.vue?vue&type=script&lang=js&"
import style0 from "./MatchEvent.vue?vue&type=style&index=0&id=56007289&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports